import React from "react";
import { styled } from "styled-components";
import rem from "../../utils/rem";
import Colors from "../../styles/Colors";
// @todo need desktop styles
const StyledSummary = styled.p `
  color: ${Colors.GRAY_DARKEST};
  font-size: ${rem(20)};
  line-height: ${rem(24)};
`;
const Summary = (props) => React.createElement(StyledSummary, { ...props });
export default Summary;
//# sourceMappingURL=Summary.js.map